
import GridEdit from "../../../assets/duotone/GridEdit.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GridEditIcon({ className, dataTestid = "GridEditIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <GridEdit data-testid={dataTestid} className={classes} {...rest} />
  );
}
